import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

export const StripeCustomerId = (props: InputComponentProps) => {
  const validate = ({ value }) =>
    value.startsWith('cus_') || "Invalid customer Id. Customer Id must start with 'cus_' prefix";

  return (
    <ValidatingInput
      autoComplete="stripe-customer-id"
      label="Customer ID"
      name="stripeCustomerId"
      placeholder="Customer ID"
      validate={validate}
      {...props}
    />
  );
};
